import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const scrollBehavior = to => {
  const position = {}
  if (to.hash) {
    position.selector = to.hash
  }
  if (to.matched.some(mm => mm.meta.scrollToTop)) {
    position.x = 0
    position.y = 0
  }
  return position
}

export function createRouter () {
  return new Router({
    mode: 'history',
    base: __dirname,
    scrollBehavior,
    routes: [
      { name: 'center-home', path: '/index', component: r => require.ensure([], () => r(require('~pages/index/login')), 'chunk-index-index') },
      { name: 'index', path: '/', redirect: '/index' },
      { path: '*', redirect: '/index' }
    ]
  })
}



// WEBPACK FOOTER //
// ./src/router/index.js